enum ConnectionCommands {
    seperator = '§',
    newMove = "newMove",
    opponentReady = "OpponentReady",
    youAreSpectator = "YouAreSpectator",
    isThereOpponent = "isThereOpponent"
}
export default ConnectionCommands;